












































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Debounced } from '@/utils/debounced';
import { searchUsersByName } from '@/utils/user';
import {requestAddReminders, requestDeleteReminders} from './reminderOperation';
import ReminderList from './reminderList.vue';

type IReminderInfo = IUser.IResponse.IUserDetailInfo;

@Component({
  components: {
    ReminderList,
  },
})
export default class ReminderOperation extends Vue {
  private editStatus = '';
  private fetching: boolean = false;
  private selectedList: string[] = [];
  private removedList: string[] = [];
  private currentReminders: IReminderInfo[] = [];
  private searchUsers: IReminderInfo[] = [];
  private addOptions: Array<{key: string, label: string}> = [];
  private historySearchUsers: IReminderInfo[] = [];
  private debouncedFetchUser: (searchVal: string) => void = new Debounced().use(this.searchUser, 500); // 节流函数
  @Prop({default: () => []}) private reminders!: IReminderInfo[];
  @Prop({default: () => ''}) private markName!: string;
  @Prop({default: ''}) private url!: string;
//   @Prop({required: true}) private submitAddReminders!: (
//     val: string[],
//     reminders: IReminderInfo[],
//   ) => Promise<string>;
//   @Prop({required: true}) private submitDelReminders!: (
//     val: string[],
//     reminders: IReminderInfo[],
//   ) => Promise<string>;

  // 获取当前的ReminderIds
  get currentReminderIds() {
    return this.currentReminders.map((reminder) => reminder.id);
  }
  // 对外暴露修改submitAddLabels方法
  public changeTheRequestFunctionForAddReminders(
    fun: (reminderIds: string[]) => Promise<string>,
  ) {
    this.submitAddReminders = fun;
  }
  // 对外暴露修改submitDelLabels方法
  public changeTheRequestFunctionForDeleteReminders(
    fun: (labelIds: string[]) => Promise<string>,
  ) {
    this.submitDelReminders = fun;
  }
  // 触发搜索用户方法
  private fetchUser(searchVal: string) {
    if (searchVal.trim() !== '') {
      this.debouncedFetchUser(searchVal);
    }
  }
  // 请求用户数据
  private searchUser(searchVal: string) {
    this.searchUsers = searchUsersByName(searchVal.trim());
  }
  // 处理选项改变，添加提醒人
  private handleChange(value: Array<{key: string, label: string}>) {
    this.selectedList = this.addOptions.map((option) => option.key);
    const historySearchUsers: IReminderInfo[] = [];
    this.searchUsers.forEach((user) => {
      if (this.selectedList.includes(user.id) ) {
        historySearchUsers.push(user);
      }
    });
    this.historySearchUsers = historySearchUsers;
  }
  // 生成新加的提醒人
  private generateAddReminders(addIdList: string[]): IReminderInfo[] {
    const addReminders: IReminderInfo[] = [];
    addIdList.forEach((addId) => {
      const findResult = this.historySearchUsers.find((user) => user.id === addId);
      addReminders.push(findResult!);
    });
    return addReminders;
  }
  // 生成保留的提醒人
  private generateReservedReminders(removeIdList: string[]): IReminderInfo[] {
    return this.reminders.filter((reminder) => !removeIdList.includes(reminder.id));
  }
  // 生成编辑后的提醒人
  private generateNewReminders(idParams: IUser.IRequest.IUpdateReminder) {
    const addReminders: IReminderInfo[] = this.generateAddReminders(idParams.addIds);
    const reservedReminders: IReminderInfo[] = this.generateReservedReminders(idParams.deleteIds);
    return addReminders.concat(reservedReminders);
  }
  private submitAddReminders(reminderIds: string[]): Promise<string> {
    return new Promise((reslove, reject) => {
      if (!this.url.trim()) {
        reject('no url');
        return;
      }
      requestAddReminders(this.url, reminderIds)
        .then((res) => {
          reslove(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  private submitDelReminders(reminderIds: string[]): Promise<string> {
    return new Promise((reslove, reject) => {
      if (!this.url.trim()) {
        reject('no url');
        return;
      }
      requestDeleteReminders(this.url, reminderIds)
        .then((res) => {
          reslove(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  // 保存编辑
  private saveEdit() {
    this.selectedList = this.selectedList.filter((addId) => !this.currentReminderIds.includes(addId));
    if (this.selectedList.length === 0 && this.removedList.length === 0) {
      this.editStatus = '';
      return;
    }
    const reminders = this.generateNewReminders({addIds: this.selectedList, deleteIds: this.removedList});
    if (this.editStatus === 'ADD') {
      this.submitAddReminders(this.selectedList).then((res) => {
        this.$message.success('Success');
        this.editStatus = '';
        this.$emit('change', reminders);
      }).catch((err) => {
        this.$message.warning(err);
      });
      return;
    }
    if (this.editStatus === 'DEL' && this.submitDelReminders) {
      this.submitDelReminders(this.removedList).then((res) => {
        this.$message.success('Success');
        this.editStatus = '';
        this.$emit('change', reminders);
      }).catch((err) => {
        this.$message.warning(err);
      });
      return;
    }
  }
  // 取消编辑
  private cancelEdit() {
    this.editStatus = '';
  }
  private handleAdd() {
    this.resetEdit();
    this.editStatus = 'ADD';
  }
  private handleDel() {
    this.resetEdit();
    this.editStatus = 'DEL';
  }
  // 重置编辑数据
  private resetEdit() {
    this.removedList = [];
    this.selectedList = [];
    this.addOptions = [];
    this.searchUsers = [];
    this.historySearchUsers = [];
    this.currentReminders = [...this.reminders];
  }
  // 删除提醒人
  private removeCurrentReminders(userId: string) {
    const newcurrentReminders = this.currentReminders.filter((user) => user.id !== userId);
    this.currentReminders = newcurrentReminders;
    this.removedList.push(userId);
  }
}
